module.exports = __webpack_public_path__ + "static/media/rate-miles.e84545a3.svg";